/**
 * 레퍼런스 : https://github.kakaocorp.com/kakaopage/api/blob/58db0cf06dce37e800e5aee64250899a8684fb30/common/src/main/java/com/kakaopage/common/model/enums/SaleType.java
 */
export enum SaleTypeVo {
  Sale = 'S', // 구매
  Refund = 'R', // 환불
}
